module.exports = __webpack_public_path__ + "static/img/2.9b9376d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/2.png
// module id = 8DOX
// module chunks = 0